export function dateToTimeAgo(date: Date): string {
	const diff = new Date().getTime() - date.getTime();
	const seconds = Math.floor(diff / 1000);

	let interval = Math.floor(seconds / 2592000);
	if (interval > 1) {
		return `${interval} months ago`;
	}

	interval = Math.floor(seconds / 86400);
	if (interval > 1) {
		return `${interval} days ago`;
	}

	interval = Math.floor(seconds / 3600);
	if (interval > 1) {
		return `${interval} hours ago`;
	}

	interval = Math.floor(seconds / 60);
	if (interval > 1) {
		return `${interval} minutes ago`;
	}

	if (seconds < 10) return `just now`;

	return `${Math.floor(seconds)} seconds ago`;
}
